import React, { useCallback, useEffect, useRef, useState } from 'react';

export const COPY_RESET_MS = 1500;

export function CopyIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function CopyButton({
  value = '',
  ariaLabel,
  className = '',
  showLabel = false,
  label = 'Copy',
}) {
  const [copied, setCopied] = useState(false);
  const copiedTimerRef = useRef(null);

  const handleClick = useCallback(async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (copied) return;

    try {
      await navigator.clipboard.writeText(value ?? '');
      setCopied(true);
      if (copiedTimerRef.current) {
        clearTimeout(copiedTimerRef.current);
      }
      copiedTimerRef.current = setTimeout(() => {
        setCopied(false);
        copiedTimerRef.current = null;
      }, COPY_RESET_MS);
    } catch {
      // Ignore clipboard failures; do not show success feedback.
    }
  }, [copied, value]);

  const stopBubble = useCallback((event) => {
    event.stopPropagation();
  }, []);

  useEffect(() => () => {
    if (copiedTimerRef.current) {
      clearTimeout(copiedTimerRef.current);
    }
  }, []);

  return (
    <button
      type="button"
      className={className}
      aria-label={copied ? 'Copied!' : ariaLabel}
      onClick={handleClick}
      onMouseDown={stopBubble}
    >
      {copied ? <CheckIcon /> : <CopyIcon />}
      {showLabel && (
        <span aria-hidden="true">{copied ? 'Copied!' : label}</span>
      )}
    </button>
  );
}

export default CopyButton;
